import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { InvoicingCutoffService } from 'src/app/services/invoicing/invoicing-cutoff.service';
import { ChargeAccountService } from 'src/app/services/others/charge-account.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-charge-account-printing-range',
  templateUrl: './charge-account-printing-range.component.html',
  styleUrls: ['./charge-account-printing-range.component.scss'],
  standalone: false
})
export class ChargeAccountPrintingRangeComponent implements OnInit {

  chargeAccountModel: InvoiceModel = new InvoiceModel();
  branchId: number = 0;
  bussinessDocumentsTypeId: number = 0;
  bussinessDocumentsTypeClassId: number = BussinessDocumentsClassEnums.cuentaCobro;
  enterpriseId: number = 0;
  initial: number = 0;
  final: number = 0;
  listChargeAccountTraffic: CustomListDropdown[] = [
    { label: "ORIGINAL CLIENTE", value: 1 },
    { label: "COPIA CLIENTE", value: 2 },
    { label: "ORIGINAL CARTERA", value: 3 },
    { label: "ARCHIVO", value: 4 },
    { label: "COPIA", value: 5 },
    { label: "CONTABILIDAD", value: 6 },
    { label: "ORIGINAL EMPRESA", value: 7 },
    { label: "ORIGINAL", value: 8 },
    { label: "CLIENTE", value: 9 }
  ];
  suscription: Subscription;
  permissionPrint: boolean = false;
  formPrintingRange: FormGroup = new FormGroup({});

  constructor(private formBuilder: FormBuilder,
    private chargeAccountService: ChargeAccountService,
    public config: DynamicDialogConfig,
    private invoicingCutoffService: InvoicingCutoffService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm();
    this.getPermissionPrint();
  }

  async ngOnInit(): Promise<void> {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.chargeAccountModel = inputs.chargeAccountModel;
    });

    if (this.chargeAccountModel.invoiceId != 0 && this.chargeAccountModel.invoiceId != -1) {
      //Válido si la fra tiene corte
      this.chargeAccountModel.invoicingCutoffId == null ? this.formPrintingRange.controls["invoicingCutoff"].disable() : this.formPrintingRange.controls["invoicingCutoff"].enable();
      this.formPrintingRange.controls["consecutiveInitial"].patchValue(this.chargeAccountModel.consecutive);
      this.formPrintingRange.controls["consecutiveFinal"].patchValue(this.chargeAccountModel.consecutive);
    }
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async changeInvoicingCutoff() {
    const consecutive = this.formPrintingRange.get("invoicingCutoff")?.value;
    if (consecutive != 0 && consecutive != null) {
      try {
        const response = await firstValueFrom(this.invoicingCutoffService.getInitialAndFinalInvoiceByKeysAsync(this.chargeAccountModel.branchId, consecutive));
        if (response.initialInvoice != null && response.initialInvoice != 0 && response.finalInvoice != null && response.finalInvoice != 0) {
          this.formPrintingRange.controls["consecutiveInitial"].patchValue(response.initialInvoice);
          this.formPrintingRange.controls["consecutiveFinal"].patchValue(response.finalInvoice);
        }
      } catch (error) {
        console.error('Error al buscar el corte por llaves.', error);
      }
    }
  }

  async getPermissionPrint() {
    try {
      // Obtenemos la respuesta de la API de manera sincrónica usando firstValueFrom
      this.permissionPrint = await firstValueFrom(this.chargeAccountService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión', error);
    }
  }

  async getPrintChargeAccounts(traffic: string) {
    try {
      const chargeAccountPrints = await firstValueFrom(this.chargeAccountService.printsChargeAccounts(this.chargeAccountModel.invoiceId, this.initial, this.final, true));
      const data: ModalObjectType = {};
      data.params = {
        traffic: traffic,
        chargeAccountPrint: chargeAccountPrints
      };
      this.ref.close(data);
    } catch (error) {
      console.error('Error al imprimir las cuentas de cobro.', error)
    }
  }

  async send() {
    if (this.formPrintingRange.valid) {
      this.initial = this.formPrintingRange.get("consecutiveInitial")?.value;
      this.final = this.formPrintingRange.get("consecutiveFinal")?.value;
      const element = this.listChargeAccountTraffic.find(x => x.value == this.formPrintingRange.get("chargeAccountTraffic")?.value);
      this.toastHandlerService.clearAllToasts();
      await this.getPrintChargeAccounts(element!.label);

      //Limpio campos
      this.validateForm();
      this.chargeAccountModel.invoicingCutoffId == null ? this.formPrintingRange.controls["invoicingCutoff"].disable() : this.formPrintingRange.controls["invoicingCutoff"].enable();
      this.formPrintingRange.controls["consecutiveInitial"].setValue(this.chargeAccountModel.consecutive);
      this.formPrintingRange.controls["consecutiveFinal"].setValue(this.chargeAccountModel.consecutive);
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Todos los campos marcados con (*) son obligatorios.'
      );
    }
  }


  validateForm() {
    this.formPrintingRange = this.formBuilder.group({
      invoicingCutoff: [0, []],
      consecutiveInitial: [0, [Validators.min(1)]],
      consecutiveFinal: [0, [Validators.min(1)]],
      chargeAccountTraffic: [0, [Validators.min(1)]]
    });
  }

}
